import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Colors } from "../../theme/colors";
import { TextInput } from "../../ui/InputFields";
import { ReactComponent as LocationIcon } from "../../images/icons/LocationIcon.svg";
import PropTypes from "prop-types";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Selectbox from "../Utils/Selectbox/Selectbox";
import { countriesList } from "../../utils/idibuJSON";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getJobSubLocationCampaign } from "../../redux/campaigns/campaigns-slice";

const AddressDetails = ({ dataObj, handleChange }: any) => {
  const structArray = [
    { Label: "Street Address", Name: "Enterprise_StreetAddress", type: "text", isIcon: true },
    { Label: "Street Address 2", Name: "Enterprise_StreetAddress2", type: "text", isIcon: true },
    { Label: "Street Address 3", Name: "Enterprise_StreetAddress3", type: "text", isIcon: true },
    { Label: "City", Name: "Enterprise_City", type: "text", isIcon: true },
    { Label: "Region", Name: "Enterprise_Region", type: "text", isIcon: true },
    { Label: "Postcode", Name: "Enterprise_Postcode", type: "number", isIcon: false },
  ];
  const [srchTxt, setSearchText] = useState('');

  const [anchorElCountry, setAnchorElCountry] = useState<null | HTMLElement>(null);
  const [country, setCountry] = useState<string>('');
  const [countryCode, setCountryCode] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<any>(null);

  const dispatch = useAppDispatch();

  const { jobSubLocation } = useAppSelector((state: any) => state.campaigns);

  const [cityValue, setCityValue] = useState<any>({
    label: '',
    value: '',
  });
  const [selectedCityValue, setSelectedCityValue] = useState<any>('');
  const [regionValue, setRegionValue] = useState<any>('');

  useEffect(() => {
    if (dataObj?.Enterprise_Country) {
      setCountry(dataObj.Enterprise_Country);
      const selected = countriesList.find(
        (c) => c.country === dataObj.Enterprise_Country
      );
      setSelectedCountry(selected || null);
    }

    if (dataObj?.Enterprise_CountryCoded) {
      setCountryCode(dataObj.Enterprise_CountryCoded);
    }
  }, []);
  const CountryCodeSelect = ({ value, onChange, labels, ...rest }: any) => (
    <select
      {...rest}
      value={value}
      onChange={(event) => {
        const val = event.target.value;
        onChange(val);
        handleChange(val, "select", "Enterprise_CountryCoded");
      }}
    >
      <option value="">{labels["ZZ"]}</option>
      {getCountries().map((country) => (
        <option key={country} value={country}>
          +{getCountryCallingCode(country)} {labels[country]}
        </option>
      ))}
    </select>
  );

  CountryCodeSelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    labels: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  const onChangeValue = (value: any) => {
    if (value) {
      setCountry(value.country);
      setSelectedCountry(value);
      setCountryCode(value.countryCode);

      setCityValue({
        label: '',
        value: '',
      })

      handleChange(value.country, "select", "Enterprise_Country");
      handleChange(value.countryCode, "select", "Enterprise_CountryCoded");
      handleChange('', 'text', 'Enterprise_City');
    }
  };


  useEffect(() => {
    if (srchTxt.length > 3) {
      const body = {
        country:
          selectedCountry?.countryCode,
        city: srchTxt,
      };
      dispatch(getJobSubLocationCampaign(body));
    }
  }, [selectedCountry, srchTxt, dispatch]);


  useEffect(() => {
    if (dataObj?.Enterprise_City) {
      const label = dataObj.Enterprise_City;
      setCityValue({ label, value: label });
      setSearchText(label.split(',')[0]);

      const body = {
        country: selectedCountry?.countryCode,
        city: label.split(',')[0],
      };
      dispatch(getJobSubLocationCampaign(body));
    }
  }, [dataObj?.Enterprise_City, selectedCountry?.countryCode, dispatch]);


  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", paddingBottom: "20px" }}>
      {structArray.map((itm, index) => (
        <Box
          key={index}
          sx={{ display: "flex", flexDirection: "column", width: "300px", marginRight: "45px", marginTop: "45px" }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 500, color: Colors.philippine_gray, marginBottom: "7px" }}>
            {itm.Label}
          </Typography>
          {itm.Label !== 'City' ? <Box sx={{ position: "relative" }}>
            <TextInput
              type={itm.type}
              maxWidth="300px"
              height="50px"
              placeholder={`Enter ${itm.Label}`}
              value={dataObj?.[itm.Name] ?? ""}
              border={`1px solid ${Colors.default}`}
              padding={"0px 10px"}
              onChange={(value) => handleChange(value, itm.type, itm.Name)}
            />
            {itm.isIcon && (
              <Box sx={{ position: "absolute", right: "20px", top: "15px" }}>
                <LocationIcon />
              </Box>
            )}
          </Box> :
            <Autocomplete
              sx={{
                borderRadius: '10px',
                '& .MuiInputBase-root': {
                  height: 47,
                  borderRadius: '10px',
                  paddingTop: '2px',
                  borderColor: '#D0D0D0 !important',
                  backgroundColor: Colors.background_grey,
                },
              }}
              onChange={(event, selection) => {
                setCityValue(selection);
                setSelectedCityValue('');

                handleChange(selection?.label, itm.type, itm.Name)
                // onChangeValue('subLocation', selection?.label ?? '');
              }}
              value={
                selectedCityValue
                  ? {
                    label:
                      jobSubLocation.find(
                        (sb) => sb.place_name === selectedCityValue
                      )?.place_name || '',
                    value: selectedCityValue,
                  }
                  : cityValue
              }
              options={
                jobSubLocation?.map((c) => ({
                  label: c.place_name + ', ' + c.region,
                  value: c.id,
                })) || []
              }
              disableClearable
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => (
                <Box component='li' {...props}>
                  {option.label}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    type: 'search',
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder='Start typing town name'
                  sx={{
                    borderColor: '#D0D0D0',
                    borderRadius: '10px',
                    '& .MuiInputBase-root': {
                      borderColor: '#D0D0D0',
                      height: 47,
                      borderRadius: '10px',
                      paddingTop: '2px',
                      color: '#919191',
                    },
                    '& .MuiAutocomplete-inputFocused': {
                      borderColor: '#D0D0D0',
                      color: '#626161',
                    },
                  }}
                />
              )}
            />}
        </Box>
      ))}



      <Box sx={{ display: "flex", flexDirection: "column", width: "300px", marginRight: "45px", marginTop: "45px" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: 500, color: Colors.philippine_gray, marginBottom: "7px" }}>
          Country
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: `1px solid ${Colors.default}`,
            height: "50px",
            borderRadius: "6px",
            padding: "0px 10px",
          }}
        >
          <Selectbox
            handleClick={(e: React.MouseEvent<HTMLDivElement>) => setAnchorElCountry(e.currentTarget)}
            handleClose={() => setAnchorElCountry(null)}
            changeBoxValue={(val) => {
              const selected = countriesList.find((c) => c.country === val);
              onChangeValue(selected);
              setAnchorElCountry(null);
            }}
            open={Boolean(anchorElCountry)}
            anchorEl={anchorElCountry}
            isCreatePage={true}
            isNotBorder={true}
            isNotBorderAdded={true}
            title={country || "Select a country"}
            menuOption={countriesList?.map((c) => c.country)}
          />
        </Box>
      </Box>

      {/* Country Code Select */}
      <Box sx={{ display: "flex", flexDirection: "column", width: "300px", marginRight: "45px", marginTop: "45px" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: 500, color: Colors.philippine_gray, marginBottom: "7px" }}>
          Country Code
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: `1px solid ${Colors.default}`,
            height: "50px",
            borderRadius: "6px",
            padding: "0px 10px",
            gap: "10px",
          }}
        >
          {countryCode && (
            <img
              style={{ width: "40px", height: "20px" }}
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`}
              alt={`${countryCode} flag`}
            />
          )}
          <CountryCodeSelect
            labels={en}
            value={countryCode}
            onChange={(val: string) => {
              setCountryCode(val);
              handleChange(val, "select", "Enterprise_CountryCoded");
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AddressDetails;
